import { useEffect, useState } from "react";
import { getLeadsCount } from "../../../api"; // Adjust the path as needed

type LeadCardProps = {
  id: number;
  title: string;
  key: string;
  icon: string;
  bgcolor: string;
};

const LeadCard: React.FC<{ data: LeadCardProps; style?: React.CSSProperties }> = ({ data, style }) => {
  const [count, setCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchLeadsCount = async () => {
      try {
        const leadsData = await getLeadsCount();
        console.log("Leads count Data:", leadsData);
        setCount(leadsData.action_counts[data.key] || 0);
      } catch (error) {
        console.error("Error fetching leads count:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLeadsCount();
  }, [data.key]);

  return (
    <div style={{ ...style, display: "flex", alignItems: "stretch" }}>
      <div
        className="card hoverable d-flex flex-column justify-content-center align-items-center p-3"
        style={{ background: data.bgcolor, width: "100%", height: "100%", padding: "16px", borderRadius: "8px" }}
      >
        {loading ? (
          <div className="text-center text-white">Loading...</div>
        ) : (
          <div className="d-flex flex-column w-100 h-100 justify-content-between" style={{padding:"10px" }}>
            {/* Top section: Icon and Title */}
            <div className="d-flex align-items-center w-100">
              <img src={data.icon} alt="icon" style={{ width: "35px", height: "35px", marginRight: "10px" }} />
              <span
                className="fw-bold fs-3"
                style={{ color: data.bgcolor === "#FFFFFF" ? "black" : "white" }}
              >
                {data.title}
              </span>
            </div>

            {/* Bottom section: Count */}
            <div className="d-flex">
              <span
                className="fw-bold fs-1"
                style={{ color: data.bgcolor === "#FFFFFF" ? "black" : "white" }}
              >
                {count}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadCard;
